import React, { useState } from 'react'
import { Drawer, Tabs, DatePicker } from 'antd'
import { Route, Switch, useHistory, useParams } from 'react-router-dom'

import { useToggle, usePet, stringifyDate, useListData } from '../../modules'

import Commentary from './commentary'
import Requests from '../reusable/requests'

const { TabPane } = Tabs
const { RangePicker } = DatePicker

const Dental = ({ onClose, patient }) => {
    const [ranges, setRanges] = useState()
    const [billedItem, setBilledItem] = useState()
    const [string, setString] = useState('')

    const history = useHistory()
    const { id } = useParams()
    
    const [visible, toggleVisible] = useToggle(true)

    usePet('billedItem', { id }, { notify: true, callback: ({ data }) => setBilledItem(data) })

    const [
        { loading: qLoading, error: qError, fetch: fetchQueue },
        { list: queue },
        { navigate: navQueue, Paginate: PagQueue, page: qPage = 1, limit: qLimit = 10 }
    ] = useListData('entriesByBilledItem', { id }, { notify: true }, 'entries')
    
    const [
        { loading: eLoading, error: eError, fetch: fetchEntries },
        { list: entries },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('entriesByPatientFromBilledItem', ranges ? { 
        id, 
        category: "Dental",
        pendingOnly: false,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null,
        string
    } : { id, string, category: "Dental", pendingOnly: false }, { notify: true }, 'entries')

    const refreshQueue = () => {
        navQueue(1)
        fetchQueue()
    }

    const refreshEntries = () => {
        navigate(1)
        fetchEntries()
    }

    const filterRequests = i => {
        if (i === "0") {
            refreshEntries()
        } else {
            refreshQueue()
        }
    }

    const close = () => {
        toggleVisible()
        onClose()
        setTimeout(() => history.goBack(), 300)
    }

    const selectRange = range => {
        setRanges(range)
        refreshEntries()
    }

    const search = str => {
        setString(str)
        refreshEntries()
    }

    const refresh = () => {
        refreshEntries()
        refreshQueue()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            // footer={
            //     <div className="w-full text-right">
            //         <Link to={ `/app/consultation/${id}/medication` }>
            //             <button onClick={ setNewTab } className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Medication</button>
            //         </Link>                    
            //         <Link to={ `/app/consultation/${id}/treatment` }>
            //             <button onClick={ setNewTab } className="text-white mr-2 bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Treatment</button>
            //         </Link>
            //         <Link to={ `/app/consultation/${id}/investigations` }>
            //             <button onClick={ setNewTab } className="text-white mr-2 bg-red-500 hover:bg-red-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Investigations</button>
            //         </Link>
            //         <Link to={ `/app/consultation/${id}/patient` }>
            //             <button onClick={ () => setBackToEntry(true) } className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">View Patient History</button>
            //         </Link>
            //     </div>
            // }
            width="50%">
            <p className="font-extrabold text-3xl mb-0">Treatment Requests</p>
            <p className="text-gray-500 text-xs italic">{ billedItem?.patient?.name ?? 'Patient' }'s visit { billedItem?.date && `on ${stringifyDate(billedItem.date)}` }</p>
            { billedItem?.sentBy && <p className="text-gray-500 font-semibold my-0 text-xs italic">Sent By { billedItem?.sentBy?.name }</p> }
            <Tabs onChange={ filterRequests } defaultActiveKey="1">
                <TabPane key="0" tab="All Requests">
                    <div className="sm:flex sm:justify-between sm:items-center mb-2">
                        <input
                            onChange={ e => search(e.target.value) }
                            className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                            id="grid-ssearch"
                            type="text"
                            placeholder="Search for item" />
                        <RangePicker onChange={selectRange} />
                    </div>
                    <Requests
                        dep="dental"
                        trailing="procedures"
                        entries={ entries }
                        error={ eError }
                        loading={ eLoading }
                        limit={ limit }
                        page={ page }
                        onComplete={ refresh }
                        Paginate={ Paginate }
                        string={ string } />
                </TabPane>
                <TabPane key="1" tab="Current">
                    <p className="font-extrabold text-lg mt-0 mb-0">Instructions</p>
                    <p className="text-gray-500 text-xs italic">{ billedItem?.instructions ?? 'None' }</p>
                    <Requests
                        dep="dental"
                        trailing="procedures"
                        entries={ queue }
                        error={ qError }
                        loading={ qLoading }
                        limit={ qLimit }
                        page={ qPage }
                        onComplete={ refresh }
                        Paginate={ PagQueue } />
                </TabPane>
            </Tabs>
            <Switch>
                <Route path="/app/dental/procedures/:id/:entry">
                    <Commentary 
                        dep="dental"
                        onClose={ refresh } />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default Dental